var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import PropTypes from 'prop-types';
import React from 'react';

var withAnswerEntered = function withAnswerEntered(WrappedComponent) {
  var AnswerEnteredProvider = function (_React$Component) {
    _inherits(AnswerEnteredProvider, _React$Component);

    function AnswerEnteredProvider(props) {
      _classCallCheck(this, AnswerEnteredProvider);

      var _this = _possibleConstructorReturn(this, (AnswerEnteredProvider.__proto__ || Object.getPrototypeOf(AnswerEnteredProvider)).call(this, props));

      _this.getChildContext = function () {
        return {
          setAnswer: _this.setAnswer,
          enteredAnswer: _this.state.enteredAnswer
        };
      };

      _this.setAnswer = function () {
        var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var selection = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var multipleChoice = arguments[2];

        var answer = value;
        if (selection) {
          var enteredAnswer = _this.state.enteredAnswer;

          answer = enteredAnswer ? [].concat(_toConsumableArray(enteredAnswer)) : [];
          var itemIndex = answer.findIndex(function (item) {
            return item === value;
          });
          if (multipleChoice) {
            itemIndex < 0 ? answer.push(value) : answer.splice(itemIndex, 1);
          } else {
            itemIndex < 0 ? answer = [value] : answer;
          }
        }
        _this.setState({
          enteredAnswer: answer
        });
      };

      _this.state = {
        enteredAnswer: null
      };
      return _this;
    }

    _createClass(AnswerEnteredProvider, [{
      key: 'render',
      value: function render() {
        var enteredAnswer = this.state.enteredAnswer;

        return React.createElement(WrappedComponent, Object.assign({
          enteredAnswer: enteredAnswer,
          setAnswer: this.setAnswer
        }, this.props));
      }
    }]);

    return AnswerEnteredProvider;
  }(React.Component);

  AnswerEnteredProvider.childContextTypes = {
    setAnswer: PropTypes.func,
    enteredAnswer: PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number]))])
  };

  return AnswerEnteredProvider;
};

export default withAnswerEntered;